import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WhatsNewService } from '../../modules/tandem-core/services/whats-new.service';
import { Release, ReleaseChange } from '../../modules/admin/models/release';
import { ModalRef } from '../../modules/tandem-core/models/modal-ref';

@Component({
  selector: 'tandem-whats-new-modal',
  templateUrl: './whats-new-modal.component.html',
  styleUrls: ['./whats-new-modal.component.scss']
})
export class WhatsNewModalComponent implements OnInit, OnDestroy {
  @Input() modalRef?: ModalRef;

  releases: Release[] = [];
  isLoading = true;

  private subscription?: Subscription;

  constructor(private whatsNewService: WhatsNewService) {}

  ngOnInit(): void {
    this.subscription = this.whatsNewService.getUnseenReleases().subscribe(releases => {
      this.releases = releases;
      this.isLoading = false;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  getCategoryIcon(category?: string): string {
    switch (category) {
      case 'feature':
        return '✨';
      case 'improvement':
        return '🚀';
      case 'fix':
        return '🔧';
      default:
        return '📝';
    }
  }

  getCategoryLabel(category?: string): string {
    switch (category) {
      case 'feature':
        return 'New Feature';
      case 'improvement':
        return 'Improvement';
      case 'fix':
        return 'Bug Fix';
      default:
        return 'Update';
    }
  }

  getCategoryClass(category?: string): string {
    switch (category) {
      case 'feature':
        return 'bg-blue-100 text-blue-800';
      case 'improvement':
        return 'bg-green-100 text-green-800';
      case 'fix':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  formatDate(timestamp: any): string {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  }

  async acknowledge(): Promise<void> {
    await this.whatsNewService.acknowledgeLatestRelease();
    this.modalRef?.close();
  }

  close(): void {
    this.modalRef?.close();
  }
}
